import React from 'react';

import {
	createRequestProviderContext,
	RequestType,
	useRequestProviderContext,
} from '@common/react/components/RequestProvider/RequestProvider';

const RequestWithTimeoutProvider: React.FC<{ timeoutMs?: number }> = ({ timeoutMs = 10000, children }) => {
	const { state, actions } = useRequestProviderContext();
	const RequestProviderContext = createRequestProviderContext();

	const wrappedRequest = React.useCallback(<T, >(
		type: string,
		data?: any,
		options?
	): Promise<T> => {
		return state.request<T>(type, data, options);
	}, [state.request, timeoutMs]);

	const value = {
		state: {
			request: wrappedRequest,
		},
		actions,
	};

	return (
		<RequestProviderContext.Provider value={value}>
			{children}
		</RequestProviderContext.Provider>
	);
};

export default RequestWithTimeoutProvider;
